import React from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "48px",
  },
}));

interface CardActionProps {
  children?: React.ReactNode;
}

const CardActions = ({ children }: CardActionProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box display="flex" className={classes.root}>
      {children}
    </Box>
  );
};
export default CardActions;
